import {getJSON} from './fetchJson'
import config from "../../config";
const baseUrlAPI = config.API_URL;

export const getViewsById = (id) => {
  if (!id) return Promise.resolve({});
  const viewUrl = `${baseUrlAPI}/view_counts?name=entityId&value=${id}`;
  return getJSON(viewUrl);
}
